// packages/transport's OHTTP client (docs/TRANSPORT.md, "Hooks for the web app"),
// imported from source. Only the client side: the gateway target is server code.
export { OhttpRelay, TransportError } from "../../../../../packages/transport/src/ohttpRelay.ts";
export type { OhttpRelayOptions } from "../../../../../packages/transport/src/ohttpRelay.ts";
